<div class="custom-paragraph-container">
  <div *ngIf="showLoader" class="loader">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <p class="paragraph-text" [innerHTML]="paragraphText | translate"></p>
</div>
